import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../../components/Footer';
import UG from "../../assets/courses/UG.gif";
import { Link } from 'react-router-dom';
import { GraduationCap, CheckCircle } from 'lucide-react';
import {
    Computer as ComputerIcon,
    Engineering as EngineeringIcon,
    Agriculture as AgricultureIcon,
    LocalPharmacy as PharmacyIcon,
    Hotel as HotelIcon,
    Business as CommerceIcon, // Changed this line - using Business as CommerceIcon
    Science as ScienceIcon,
    Build as BuildIcon,
    MedicalServices as HealthIcon,
    Palette as ArtsIcon,
    Accessibility as RehabIcon,
    Healing as NursingIcon,
    Emergency as ParamedicalIcon,
    Gavel as LawIcon,
    School as EducationIcon,
    Work as VocationalIcon, 
} from '@mui/icons-material';

const ugSchools = [
    {
        name: 'School of Computer Engineering and Applications',
        icon: ComputerIcon,
        courses: [
            {
                name: 'B.Tech. Computer Science & Engineering with IBM',
                description: 'Comprehensive program in computer science with IBM collaboration, focusing on industry-relevant skills.',
                duration: '4 Years',
                eligibility: '10+2 with PCM and minimum 50% marks',
                features: [
                    'Industry-Aligned Curriculum',
                    'Cloud Computing',
                    'Software Development',
                    'IBM Certification',
                    'Project-Based Learning'
                ],
                careerOpportunities: [
                    'Software Engineer',
                    'Cloud Architect',
                    'System Analyst',
                    'IT Consultant',
                    'Application Developer'
                ]
            },
            {
                name: 'B.Tech. Computer Science & Engineering (AIML) with IBM',
                description: 'Specialized program in AI and Machine Learning with IBM, emphasizing advanced algorithms and data models.',
                duration: '4 Years',
                eligibility: '10+2 with PCM and minimum 50% marks',
                features: [
                    'Machine Learning Models',
                    'Deep Learning Techniques',
                    'IBM AI Tools',
                    'Data Analytics',
                    'AI Project Development'
                ],
                careerOpportunities: [
                    'AI Engineer',
                    'Machine Learning Specialist',
                    'Data Scientist',
                    'AI Research Analyst',
                    'Robotics Engineer'
                ]
            },
            {
                name: 'B.Tech. Computer Science & Engineering (Data Science) with IBM',
                description: 'Focused program on data science with IBM, covering data analysis, visualization, and predictive modeling.',
                duration: '4 Years',
                eligibility: '10+2 with PCM and minimum 50% marks',
                features: [
                    'Big Data Analytics',
                    'Data Visualization Tools',
                    'IBM Data Science Tools',
                    'Statistical Modeling',
                    'Real-World Data Projects'
                ],
                careerOpportunities: [
                    'Data Scientist',
                    'Data Analyst',
                    'Business Intelligence Analyst',
                    'Data Engineer',
                    'Big Data Specialist'
                ]
            },
            {
                name: 'B.Tech. Computer Science & Engineering (Cyber Security & Forensics) with IBM',
                description: 'Specialized program in cyber security and digital forensics with IBM, focusing on threat detection and mitigation.',
                duration: '4 Years',
                eligibility: '10+2 with PCM and minimum 50% marks',
                features: [
                    'Cyber Threat Analysis',
                    'Digital Forensics',
                    'IBM Security Tools',
                    'Network Security',
                    'Ethical Hacking'
                ],
                careerOpportunities: [
                    'Cybersecurity Analyst',
                    'Digital Forensics Expert',
                    'Security Consultant',
                    'Penetration Tester',
                    'Information Security Manager'
                ]
            },
            {
                name: 'B.Tech. Computer Science & Engineering',
                description: 'Core program in computer science, covering programming, algorithms, and system design.',
                duration: '4 Years',
                eligibility: '10+2 with PCM and minimum 50% marks',
                features: [
                    'Programming Fundamentals',
                    'Database Management',
                    'Operating Systems',
                    'Web Development',
                    'Software Engineering'
                ],
                careerOpportunities: [
                    'Software Developer',
                    'System Engineer',
                    'Web Developer',
                    'Database Administrator',
                    'IT Project Manager'
                ]
            },
            {
                name: 'B.Tech. Computer Science & Engineering (AIML)',
                description: 'Focused program in AI and Machine Learning, covering neural networks and intelligent systems.',
                duration: '4 Years',
                eligibility: '10+2 with PCM and minimum 50% marks',
                features: [
                    'Neural Networks',
                    'Natural Language Processing',
                    'Computer Vision',
                    'AI Algorithms',
                    'Machine Learning Frameworks'
                ],
                careerOpportunities: [
                    'AI Developer',
                    'Machine Learning Engineer',
                    'Data Scientist',
                    'AI Consultant',
                    'Robotics Specialist'
                ]
            },
            {
                name: 'B.Tech. Computer Science & Engineering (Data Science)',
                description: 'Program emphasizing data science techniques, including data mining and statistical analysis.',
                duration: '4 Years',
                eligibility: '10+2 with PCM and minimum 50% marks',
                features: [
                    'Data Mining Techniques',
                    'Predictive Analytics',
                    'Data Visualization',
                    'Machine Learning for Data',
                    'Big Data Technologies'
                ],
                careerOpportunities: [
                    'Data Analyst',
                    'Data Scientist',
                    'Business Analyst',
                    'Data Engineer',
                    'Analytics Consultant'
                ]
            },
            {
                name: 'B.Tech. Computer Science & Engineering (Cyber Security)',
                description: 'Program focused on securing digital systems and networks from cyber threats.',
                duration: '4 Years',
                eligibility: '10+2 with PCM and minimum 50% marks',
                features: [
                    'Network Security Protocols',
                    'Cryptography',
                    'Cyber Threat Intelligence',
                    'Security Auditing',
                    'Incident Response'
                ],
                careerOpportunities: [
                    'Security Analyst',
                    'Cybersecurity Engineer',
                    'Ethical Hacker',
                    'Security Operations Specialist',
                    'Information Security Officer'
                ]
            },
            {
                name: 'B.Tech. Computer Science & Engineering (LE)',
                description: 'Lateral entry program for diploma holders to pursue advanced computer science studies.',
                duration: '3 Years',
                eligibility: 'Diploma in Engineering with minimum 50% marks',
                features: [
                    'Advanced Programming',
                    'System Architecture',
                    'Software Design',
                    'Cloud Computing',
                    'Project Development'
                ],
                careerOpportunities: [
                    'Software Engineer',
                    'System Analyst',
                    'Application Developer',
                    'IT Consultant',
                    'Technical Lead'
                ]
            },
            {
                name: 'BCA',
                description: 'Undergraduate program in computer applications, focusing on software development and IT skills.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Programming in C and Java',
                    'Web Technologies',
                    'Database Management',
                    'Software Testing',
                    'Mobile App Development'
                ],
                careerOpportunities: [
                    'Software Developer',
                    'Web Designer',
                    'Database Administrator',
                    'System Analyst',
                    'IT Support Specialist'
                ]
            },
            {
                name: 'BCA AIML',
                description: 'Specialized BCA program focusing on AI and Machine Learning applications.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'AI Programming',
                    'Machine Learning Algorithms',
                    'Data Analysis',
                    'Neural Networks',
                    'AI Application Development'
                ],
                careerOpportunities: [
                    'AI Developer',
                    'Data Analyst',
                    'Machine Learning Engineer',
                    'AI Support Specialist',
                    'Research Assistant'
                ]
            },
            {
                name: 'BCA Data Science',
                description: 'BCA program with a focus on data science and analytics for IT applications.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Data Analytics Tools',
                    'Statistical Methods',
                    'Big Data Frameworks',
                    'Data Visualization',
                    'Predictive Modeling'
                ],
                careerOpportunities: [
                    'Data Analyst',
                    'Business Intelligence Analyst',
                    'Data Engineer',
                    'Analytics Consultant',
                    'Data Science Specialist'
                ]
            },
            {
                name: 'BCA Cyber Security',
                description: 'BCA program specializing in cyber security for protecting IT systems and data.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Cybersecurity Fundamentals',
                    'Network Security',
                    'Ethical Hacking',
                    'Digital Forensics',
                    'Security Policy Development'
                ],
                careerOpportunities: [
                    'Cybersecurity Analyst',
                    'Security Administrator',
                    'Ethical Hacker',
                    'IT Security Consultant',
                    'Network Security Specialist'
                ]
            },
            {
                name: 'B.Sc. Information Technology',
                description: 'Program focusing on IT infrastructure, networking, and software applications.',
                duration: '3 Years',
                eligibility: '10+2 with PCM and minimum 45% marks',
                features: [
                    'Network Administration',
                    'Web Development',
                    'IT Infrastructure Management',
                    'Cloud Computing',
                    'Cybersecurity Basics'
                ],
                careerOpportunities: [
                    'IT Specialist',
                    'Network Administrator',
                    'Web Developer',
                    'IT Support Engineer',
                    'System Administrator'
                ]
            },
            {
                name: 'B.Sc. Computer Science',
                description: 'Program covering core computer science concepts, programming, and system design.',
                duration: '3 Years',
                eligibility: '10+2 with PCM and minimum 45% marks',
                features: [
                    'Programming Languages',
                    'Data Structures',
                    'Algorithms',
                    'Operating Systems',
                    'Database Systems'
                ],
                careerOpportunities: [
                    'Software Developer',
                    'System Analyst',
                    'Database Administrator',
                    'Programmer',
                    'IT Consultant'
                ]
            }
        ]
    },
    {
        name: 'School of Hotel Management and Tourism',
        icon: HotelIcon,
        courses: [
            {
                name: 'Bachelor of Hotel Management (BHM)',
                description: 'Comprehensive program in hotel management, covering hospitality operations and customer service.',
                duration: '4 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Hospitality Management',
                    'Food and Beverage Service',
                    'Front Office Operations',
                    'Housekeeping Management',
                    'Event Management'
                ],
                careerOpportunities: [
                    'Hotel Manager',
                    'Front Office Manager',
                    'Food and Beverage Manager',
                    'Event Coordinator',
                    'Hospitality Consultant'
                ]
            },
            {
                name: 'Bachelor of Hotel Management (LE)',
                description: 'Lateral entry program for diploma holders in hotel management.',
                duration: '3 Years',
                eligibility: 'Diploma in Hotel Management with minimum 50% marks',
                features: [
                    'Advanced Hospitality Operations',
                    'Revenue Management',
                    'Customer Relationship Management',
                    'Hotel Marketing',
                    'Industry Internships'
                ],
                careerOpportunities: [
                    'Hotel Operations Manager',
                    'Guest Relations Manager',
                    'Banquet Manager',
                    'Hospitality Trainer',
                    'Resort Manager'
                ]
            },
            {
                name: 'Bachelor of Hotel Management & Catering Technology (BHMCT)',
                description: 'Program combining hotel management with culinary arts and catering technology.',
                duration: '4 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Culinary Arts',
                    'Catering Operations',
                    'Menu Planning',
                    'Food Safety Standards',
                    'Hospitality Technology'
                ],
                careerOpportunities: [
                    'Catering Manager',
                    'Executive Chef',
                    'Food Production Manager',
                    'Hospitality Consultant',
                    'Banquet Manager'
                ]
            },
            {
                name: 'Bachelor of Hotel Management & Catering Technology (LE)',
                description: 'Lateral entry program for diploma holders in hotel management and catering.',
                duration: '3 Years',
                eligibility: 'Diploma in Hotel Management/Catering with minimum 50% marks',
                features: [
                    'Advanced Culinary Techniques',
                    'Catering Business Management',
                    'Food Innovation',
                    'Hospitality Marketing',
                    'Industry Projects'
                ],
                careerOpportunities: [
                    'Catering Operations Manager',
                    'Culinary Consultant',
                    'Food Service Manager',
                    'Event Catering Specialist',
                    'Hospitality Entrepreneur'
                ]
            }
        ]
    },
    {
        name: 'School of Engineering',
        icon: EngineeringIcon,
        courses: [
            {
                name: 'B.Tech. Mechanical Engineering (Mechatronics)',
                description: 'Program combining mechanical engineering with electronics and robotics.',
                duration: '4 Years',
                eligibility: '10+2 with PCM and minimum 50% marks',
                features: [
                    'Robotics Engineering',
                    'Automation Systems',
                    'Control Systems',
                    'Mechatronics Design',
                    'Industry Projects'
                ],
                careerOpportunities: [
                    'Mechatronics Engineer',
                    'Robotics Specialist',
                    'Automation Engineer',
                    'Control Systems Designer',
                    'Manufacturing Engineer'
                ]
            },
            {
                name: 'B.Tech. Civil Engineering (Structural Engineering)',
                description: 'Specialized program in civil engineering with a focus on structural design and analysis.',
                duration: '4 Years',
                eligibility: '10+2 with PCM and minimum 50% marks',
                features: [
                    'Structural Analysis',
                    'Concrete Technology',
                    'Steel Structures',
                    'Earthquake Engineering',
                    'CAD Design'
                ],
                careerOpportunities: [
                    'Structural Engineer',
                    'Civil Engineer',
                    'Construction Manager',
                    'Design Consultant',
                    'Project Engineer'
                ]
            },
            {
                name: 'B.Tech. ECE (VLSI & Embedded System)',
                description: 'Program in electronics and communication with a focus on VLSI and embedded systems.',
                duration: '4 Years',
                eligibility: '10+2 with PCM and minimum 50% marks',
                features: [
                    'VLSI Design',
                    'Embedded Systems Programming',
                    'Microcontrollers',
                    'Circuit Design',
                    'IoT Applications'
                ],
                careerOpportunities: [
                    'VLSI Engineer',
                    'Embedded Systems Developer',
                    'Electronics Engineer',
                    'IoT Specialist',
                    'Chip Designer'
                ]
            },
            {
                name: 'B.Tech. ECE (Robotics & AI)',
                description: 'Program focusing on robotics and AI applications in electronics and communication.',
                duration: '4 Years',
                eligibility: '10+2 with PCM and minimum 50% marks',
                features: [
                    'Robotics Programming',
                    'AI Algorithms',
                    'Sensor Technology',
                    'Control Systems',
                    'Automation Projects'
                ],
                careerOpportunities: [
                    'Robotics Engineer',
                    'AI Developer',
                    'Automation Specialist',
                    'Control Systems Engineer',
                    'Research Scientist'
                ]
            },
            {
                name: 'B.Tech. Aerospace Engineering',
                description: 'Program covering aerodynamics, propulsion, and spacecraft design.',
                duration: '4 Years',
                eligibility: '10+2 with PCM and minimum 50% marks',
                features: [
                    'Aerodynamics',
                    'Aircraft Structures',
                    'Propulsion Systems',
                    'Spacecraft Design',
                    'Flight Testing'
                ],
                careerOpportunities: [
                    'Aerospace Engineer',
                    'Aircraft Designer',
                    'Avionics Engineer',
                    'Flight Test Engineer',
                    'Spacecraft Systems Engineer'
                ]
            },
            {
                name: 'B.Tech. (LE) Mechanical Engineering',
                description: 'Lateral entry program for diploma holders in mechanical engineering.',
                duration: '3 Years',
                eligibility: 'Diploma in Mechanical Engineering with minimum 50% marks',
                features: [
                    'Advanced Mechanics',
                    'Thermodynamics',
                    'CAD/CAM',
                    'Manufacturing Processes',
                    'Industry Projects'
                ],
                careerOpportunities: [
                    'Mechanical Engineer',
                    'Design Engineer',
                    'Production Manager',
                    'Quality Control Engineer',
                    'Maintenance Engineer'
                ]
            },
            {
                name: 'B.Tech. (LE) Civil Engineering',
                description: 'Lateral entry program for diploma holders in civil engineering.',
                duration: '3 Years',
                eligibility: 'Diploma in Civil Engineering with minimum 50% marks',
                features: [
                    'Structural Design',
                    'Construction Management',
                    'Surveying Techniques',
                    'Geotechnical Engineering',
                    'Project Work'
                ],
                careerOpportunities: [
                    'Civil Engineer',
                    'Site Engineer',
                    'Construction Supervisor',
                    'Structural Consultant',
                    'Project Manager'
                ]
            },
            {
                name: 'B.Tech. (LE) Electronics and Communication Engineering (ECE)',
                description: 'Lateral entry program for diploma holders in electronics and communication.',
                duration: '3 Years',
                eligibility: 'Diploma in ECE with minimum 50% marks',
                features: [
                    'Digital Electronics',
                    'Communication Systems',
                    'Microprocessors',
                    'Signal Processing',
                    'Industry Projects'
                ],
                careerOpportunities: [
                    'Electronics Engineer',
                    'Communication Engineer',
                    'Embedded Systems Developer',
                    'Signal Processing Specialist',
                    'Telecom Engineer'
                ]
            }
        ]
    },
    {
        name: 'School of Commerce and Management',
        icon: CommerceIcon,
        courses: [
            {
                name: 'BBA Human Resources',
                description: 'Program focusing on HR management, recruitment, and employee relations.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Recruitment Strategies',
                    'Employee Training',
                    'Organizational Behavior',
                    'Labor Laws',
                    'HR Analytics'
                ],
                careerOpportunities: [
                    'HR Manager',
                    'Recruitment Specialist',
                    'Employee Relations Officer',
                    'Training Coordinator',
                    'HR Consultant'
                ]
            },
            {
                name: 'BBA Aviation Management',
                description: 'Program covering aviation industry operations and management.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Airport Operations',
                    'Aviation Safety',
                    'Airline Management',
                    'Customer Service',
                    'Logistics Planning'
                ],
                careerOpportunities: [
                    'Airport Manager',
                    'Airline Operations Manager',
                    'Aviation Safety Officer',
                    'Ground Handling Supervisor',
                    'Aviation Consultant'
                ]
            },
            {
                name: 'BBA Marketing Management',
                description: 'Program focusing on marketing strategies, branding, and consumer behavior.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Market Research',
                    'Brand Management',
                    'Digital Marketing',
                    'Consumer Behavior',
                    'Sales Strategies'
                ],
                careerOpportunities: [
                    'Marketing Manager',
                    'Brand Manager',
                    'Sales Executive',
                    'Market Research Analyst',
                    'Advertising Specialist'
                ]
            },
            {
                name: 'BBA FinTech',
                description: 'Program combining finance and technology for innovative financial solutions.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Blockchain Technology',
                    'Digital Payments',
                    'Financial Analytics',
                    'FinTech Regulations',
                    'Startup Ecosystem'
                ],
                careerOpportunities: [
                    'FinTech Analyst',
                    'Blockchain Developer',
                    'Financial Consultant',
                    'Digital Banking Specialist',
                    'Investment Analyst'
                ]
            },
            {
                name: 'BBA Digital Marketing',
                description: 'Program focusing on online marketing, SEO, and social media strategies.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'SEO Optimization',
                    'Social Media Marketing',
                    'Content Marketing',
                    'Analytics Tools',
                    'Digital Campaign Management'
                ],
                careerOpportunities: [
                    'Digital Marketing Manager',
                    'SEO Specialist',
                    'Social Media Manager',
                    'Content Strategist',
                    'Digital Advertising Expert'
                ]
            },
            {
                name: 'BBA Logistic Management',
                description: 'Program covering supply chain management and logistics operations.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Supply Chain Management',
                    'Warehouse Operations',
                    'Transportation Logistics',
                    'Inventory Control',
                    'Global Trade'
                ],
                careerOpportunities: [
                    'Logistics Manager',
                    'Supply Chain Analyst',
                    'Warehouse Manager',
                    'Freight Coordinator',
                    'Operations Manager'
                ]
            },
            {
                name: 'B.Com Finance',
                description: 'Program focusing on financial management, investment, and banking.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Financial Accounting',
                    'Investment Analysis',
                    'Banking Operations',
                    'Corporate Finance',
                    'Risk Management'
                ],
                careerOpportunities: [
                    'Financial Analyst',
                    'Bank Officer',
                    'Investment Advisor',
                    'Accountant',
                    'Finance Manager'
                ]
            },
            {
                name: 'B.Com Taxation and Accounting',
                description: 'Program covering taxation laws, accounting principles, and auditing.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Taxation Laws',
                    'Financial Accounting',
                    'Auditing Techniques',
                    'Cost Accounting',
                    'GST Compliance'
                ],
                careerOpportunities: [
                    'Tax Consultant',
                    'Accountant',
                    'Auditor',
                    'Tax Analyst',
                    'Financial Controller'
                ]
            }
        ]
    },
    {
        name: 'School of Life and Applied Science',
        icon: ScienceIcon,
        courses: [
            {
                name: 'B.Sc. Non-Medical (PCM)',
                description: 'Program in Physics, Chemistry, and Mathematics for scientific and technical careers.',
                duration: '3 Years',
                eligibility: '10+2 with PCM and minimum 45% marks',
                features: [
                    'Advanced Physics',
                    'Organic Chemistry',
                    'Mathematical Modeling',
                    'Lab Experiments',
                    'Research Projects'
                ],
                careerOpportunities: [
                    'Research Assistant',
                    'Lab Technician',
                    'Data Analyst',
                    'Science Educator',
                    'Technical Consultant'
                ]
            },
            {
                name: 'B.Sc. Medical (CBZ)',
                description: 'Program in Chemistry, Botany, and Zoology for medical and biological sciences.',
                duration: '3 Years',
                eligibility: '10+2 with PCB and minimum 45% marks',
                features: [
                    'Human Anatomy',
                    'Plant Biology',
                    'Animal Physiology',
                    'Biochemistry',
                    'Lab Work'
                ],
                careerOpportunities: [
                    'Medical Lab Technician',
                    'Biologist',
                    'Research Assistant',
                    'Science Teacher',
                    'Environmental Consultant'
                ]
            },
            {
                name: 'B.Sc. Physics',
                description: 'Program focusing on classical and modern physics concepts.',
                duration: '3 Years',
                eligibility: '10+2 with PCM and minimum 45% marks',
                features: [
                    'Quantum Mechanics',
                    'Electromagnetism',
                    'Thermodynamics',
                    'Optics',
                    'Physics Lab'
                ],
                careerOpportunities: [
                    'Physicist',
                    'Research Scientist',
                    'Lab Manager',
                    'Physics Educator',
                    'Technical Analyst'
                ]
            },
            {
                name: 'B.Sc. Chemistry',
                description: 'Program covering organic, inorganic, and physical chemistry.',
                duration: '3 Years',
                eligibility: '10+2 with PCM/PCB and minimum 45% marks',
                features: [
                    'Organic Synthesis',
                    'Inorganic Chemistry',
                    'Analytical Techniques',
                    'Chemical Kinetics',
                    'Lab Research'
                ],
                careerOpportunities: [
                    'Chemist',
                    'Quality Control Analyst',
                    'Research Associate',
                    'Chemistry Teacher',
                    'Pharmaceutical Analyst'
                ]
            },
            {
                name: 'B.Sc. Maths',
                description: 'Program focusing on advanced mathematical theories and applications.',
                duration: '3 Years',
                eligibility: '10+2 with PCM and minimum 45% marks',
                features: [
                    'Calculus',
                    'Linear Algebra',
                    'Probability Theory',
                    'Numerical Analysis',
                    'Mathematical Modeling'
                ],
                careerOpportunities: [
                    'Mathematician',
                    'Data Analyst',
                    'Statistician',
                    'Actuary',
                    'Math Educator'
                ]
            },
            {
                name: 'B.Sc. Zoology',
                description: 'Program studying animal biology, physiology, and ecology.',
                duration: '3 Years',
                eligibility: '10+2 with PCB and minimum 45% marks',
                features: [
                    'Animal Physiology',
                    'Ecology',
                    'Genetics',
                    'Wildlife Conservation',
                    'Zoology Lab'
                ],
                careerOpportunities: [
                    'Zoologist',
                    'Wildlife Biologist',
                    'Conservationist',
                    'Research Assistant',
                    'Zoo Curator'
                ]
            },
            {
                name: 'B.Sc. Botany',
                description: 'Program focusing on plant biology, taxonomy, and ecology.',
                duration: '3 Years',
                eligibility: '10+2 with PCB and minimum 45% marks',
                features: [
                    'Plant Physiology',
                    'Taxonomy',
                    'Ecology',
                    'Biotechnology',
                    'Botany Lab'
                ],
                careerOpportunities: [
                    'Botanist',
                    'Plant Ecologist',
                    'Horticulturist',
                    'Research Scientist',
                    'Environmental Consultant'
                ]
            },
            {
                name: 'B.Sc. Environmental Science',
                description: 'Program addressing environmental issues, conservation, and sustainability.',
                duration: '3 Years',
                eligibility: '10+2 with PCB/PCM and minimum 45% marks',
                features: [
                    'Environmental Monitoring',
                    'Conservation Techniques',
                    'Pollution Control',
                    'Sustainable Development',
                    'Field Research'
                ],
                careerOpportunities: [
                    'Environmental Scientist',
                    'Conservation Officer',
                    'Sustainability Consultant',
                    'Environmental Educator',
                    'Policy Analyst'
                ]
            },
            {
                name: 'B.Sc. Forensic Science',
                description: 'Program covering forensic techniques for crime investigation.',
                duration: '3 Years',
                eligibility: '10+2 with PCB/PCM and minimum 45% marks',
                features: [
                    'Crime Scene Analysis',
                    'Forensic Chemistry',
                    'DNA Profiling',
                    'Toxicology',
                    'Forensic Lab'
                ],
                careerOpportunities: [
                    'Forensic Scientist',
                    'Crime Scene Investigator',
                    'Forensic Analyst',
                    'Toxicologist',
                    'Lab Technician'
                ]
            },
            {
                name: 'B.Sc. Microbiology',
                description: 'Program studying microorganisms and their applications in health and industry.',
                duration: '3 Years',
                eligibility: '10+2 with PCB and minimum 45% marks',
                features: [
                    'Microbial Genetics',
                    'Immunology',
                    'Medical Microbiology',
                    'Industrial Microbiology',
                    'Lab Techniques'
                ],
                careerOpportunities: [
                    'Microbiologist',
                    'Clinical Researcher',
                    'Quality Control Analyst',
                    'Lab Technician',
                    'Biotech Scientist'
                ]
            },
            {
                name: 'B.Sc. Biotechnology',
                description: 'Program combining biology and technology for medical and industrial applications.',
                duration: '3 Years',
                eligibility: '10+2 with PCB and minimum 45% marks',
                features: [
                    'Genetic Engineering',
                    'Molecular Biology',
                    'Bioinformatics',
                    'Bioprocess Technology',
                    'Lab Research'
                ],
                careerOpportunities: [
                    'Biotechnologist',
                    'Research Scientist',
                    'Bioinformatics Analyst',
                    'Quality Control Analyst',
                    'Biotech Consultant'
                ]
            },
            {
                name: 'B.Sc. (Hons) Physics',
                description: 'Advanced program in physics with research-oriented curriculum.',
                duration: '3 Years',
                eligibility: '10+2 with PCM and minimum 50% marks',
                features: [
                    'Quantum Physics',
                    'Astrophysics',
                    'Solid State Physics',
                    'Research Methodology',
                    'Advanced Lab'
                ],
                careerOpportunities: [
                    'Research Physicist',
                    'Astrophysicist',
                    'Physics Professor',
                    'R&D Scientist',
                    'Technical Consultant'
                ]
            },
            {
                name: 'B.Sc. (Hons) Chemistry',
                description: 'Advanced program in chemistry with a focus on research and innovation.',
                duration: '3 Years',
                eligibility: '10+2 with PCM/PCB and minimum 50% marks',
                features: [
                    'Advanced Organic Chemistry',
                    'Spectroscopy',
                    'Polymer Chemistry',
                    'Research Projects',
                    'Lab Innovations'
                ],
                careerOpportunities: [
                    'Research Chemist',
                    'Chemical Analyst',
                    'Chemistry Professor',
                    'Pharmaceutical Researcher',
                    'R&D Manager'
                ]
            },
            {
                name: 'B.Sc. (Hons) Maths',
                description: 'Advanced program in mathematics with applications in research and industry.',
                duration: '3 Years',
                eligibility: '10+2 with PCM and minimum 50% marks',
                features: [
                    'Abstract Algebra',
                    'Differential Geometry',
                    'Mathematical Modeling',
                    'Statistical Analysis',
                    'Research Projects'
                ],
                careerOpportunities: [
                    'Mathematician',
                    'Data Scientist',
                    'Statistician',
                    'Research Analyst',
                    'Professor'
                ]
            },
            {
                name: 'B.Sc. (Hons) Zoology',
                description: 'Advanced program in zoology with a focus on research and conservation.',
                duration: '3 Years',
                eligibility: '10+2 with PCB and minimum 50% marks',
                features: [
                    'Advanced Animal Behavior',
                    'Conservation Biology',
                    'Evolutionary Biology',
                    'Research Methodology',
                    'Field Studies'
                ],
                careerOpportunities: [
                    'Zoologist',
                    'Wildlife Researcher',
                    'Conservation Scientist',
                    'Professor',
                    'Wildlife Consultant'
                ]
            },
            {
                name: 'B.Sc. (Hons) Botany',
                description: 'Advanced program in botany with a focus on plant research and applications.',
                duration: '3 Years',
                eligibility: '10+2 with PCB and minimum 50% marks',
                features: [
                    'Plant Biotechnology',
                    'Ecology Studies',
                    'Plant Pathology',
                    'Research Projects',
                    'Field Work'
                ],
                careerOpportunities: [
                    'Botanist',
                    'Plant Researcher',
                    'Ecologist',
                    'Professor',
                    'Horticulture Specialist'
                ]
            },
            {
                name: 'B.Sc. (Hons) Environmental Science',
                description: 'Advanced program in environmental science with a focus on sustainability and research.',
                duration: '3 Years',
                eligibility: '10+2 with PCB/PCM and minimum 50% marks',
                features: [
                    'Climate Change Studies',
                    'Environmental Policy',
                    'Sustainable Development',
                    'Research Methodology',
                    'Field Research'
                ],
                careerOpportunities: [
                    'Environmental Scientist',
                    'Sustainability Consultant',
                    'Policy Analyst',
                    'Professor',
                    'Conservation Manager'
                ]
            },
            {
                name: 'B.Sc. (Hons) Forensic Science',
                description: 'Advanced program in forensic science with a focus on crime investigation and research.',
                duration: '3 Years',
                eligibility: '10+2 with PCB/PCM and minimum 50% marks',
                features: [
                    'Advanced Forensic Techniques',
                    'Criminalistics',
                    'Forensic Pathology',
                    'Research Projects',
                    'Lab Analysis'
                ],
                careerOpportunities: [
                    'Forensic Scientist',
                    'Crime Lab Analyst',
                    'Forensic Consultant',
                    'Professor',
                    'Investigation Specialist'
                ]
            },
            {
                name: 'B.Sc. (Hons) Microbiology',
                description: 'Advanced program in microbiology with a focus on research and applications.',
                duration: '3 Years',
                eligibility: '10+2 with PCB and minimum 50% marks',
                features: [
                    'Advanced Microbial Techniques',
                    'Virology',
                    'Biotechnology Applications',
                    'Research Projects',
                    'Lab Work'
                ],
                careerOpportunities: [
                    'Microbiologist',
                    'Research Scientist',
                    'Clinical Microbiologist',
                    'Professor',
                    'Biotech Researcher'
                ]
            },
            {
                name: 'B.Sc. (Hons) Biotechnology',
                description: 'Advanced program in biotechnology with a focus on research and innovation.',
                duration: '3 Years',
                eligibility: '10+2 with PCB and minimum 50% marks',
                features: [
                    'Genetic Engineering',
                    'Bioprocess Engineering',
                    'Bioinformatics',
                    'Research Methodology',
                    'Lab Innovations'
                ],
                careerOpportunities: [
                    'Biotechnologist',
                    'Research Scientist',
                    'Bioinformatics Specialist',
                    'Professor',
                    'Biotech Consultant'
                ]
            }
        ]
    },
    {
        name: 'School of Pharmacy (PCI Approved)',
        icon: PharmacyIcon,
        courses: [
            {
                name: 'B. Pharma',
                description: 'Comprehensive program in pharmaceutical sciences approved by PCI.',
                duration: '4 Years',
                eligibility: '10+2 with PCB/PCM and minimum 50% marks',
                features: [
                    'Pharmaceutical Chemistry',
                    'Pharmacology',
                    'Pharmaceutics',
                    'Clinical Pharmacy',
                    'Industry Internships'
                ],
                careerOpportunities: [
                    'Pharmacist',
                    'Pharmaceutical Researcher',
                    'Quality Control Analyst',
                    'Regulatory Affairs Specialist',
                    'Clinical Research Associate'
                ]
            },
            {
                name: 'B. Pharma (LE)',
                description: 'Lateral entry program for diploma holders in pharmacy.',
                duration: '3 Years',
                eligibility: 'Diploma in Pharmacy with minimum 50% marks',
                features: [
                    'Advanced Pharmacology',
                    'Drug Formulation',
                    'Pharmaceutical Analysis',
                    'Clinical Research',
                    'Industry Projects'
                ],
                careerOpportunities: [
                    'Pharmacist',
                    'Drug Development Scientist',
                    'Quality Assurance Manager',
                    'Pharmaceutical Consultant',
                    'Clinical Trial Coordinator'
                ]
            }
        ]
    },
    {
        name: 'School of Agriculture and Technology',
        icon: AgricultureIcon,
        courses: [
            {
                name: 'B.Sc. (Hons) Agriculture',
                description: 'Advanced program in agriculture with a focus on modern farming techniques.',
                duration: '4 Years',
                eligibility: '10+2 with PCB/PCM and minimum 50% marks',
                features: [
                    'Crop Production',
                    'Soil Science',
                    'Agribusiness Management',
                    'Precision Farming',
                    'Field Research'
                ],
                careerOpportunities: [
                    'Agronomist',
                    'Agricultural Consultant',
                    'Farm Manager',
                    'Agribusiness Entrepreneur',
                    'Research Scientist'
                ]
            },
            {
                name: 'B.Sc. (Hons) Horticulture',
                description: 'Advanced program in horticulture focusing on plant cultivation and landscaping.',
                duration: '4 Years',
                eligibility: '10+2 with PCB/PCM and minimum 50% marks',
                features: [
                    'Ornamental Horticulture',
                    'Fruit and Vegetable Cultivation',
                    'Landscape Design',
                    'Greenhouse Management',
                    'Field Work'
                ],
                careerOpportunities: [
                    'Horticulturist',
                    'Landscape Designer',
                    'Nursery Manager',
                    'Agricultural Consultant',
                    'Research Scientist'
                ]
            },
            {
                name: 'B.Sc. Food Technology',
                description: 'Program focusing on food processing, safety, and quality control.',
                duration: '3 Years',
                eligibility: '10+2 with PCB/PCM and minimum 45% marks',
                features: [
                    'Food Processing Techniques',
                    'Food Safety Standards',
                    'Quality Control',
                    'Nutrition Science',
                    'Lab Analysis'
                ],
                careerOpportunities: [
                    'Food Technologist',
                    'Quality Control Analyst',
                    'Food Safety Officer',
                    'Product Development Specialist',
                    'Nutrition Consultant'
                ]
            },
            {
                name: 'B.Sc. (Hons) Food Technology',
                description: 'Advanced program in food technology with a focus on research and innovation.',
                duration: '4 Years',
                eligibility: '10+2 with PCB/PCM and minimum 50% marks',
                features: [
                    'Advanced Food Processing',
                    'Food Biotechnology',
                    'Packaging Technology',
                    'Research Projects',
                    'Industry Internships'
                ],
                careerOpportunities: [
                    'Food Scientist',
                    'Research and Development Manager',
                    'Food Safety Consultant',
                    'Quality Assurance Manager',
                    'Food Technologist'
                ]
            },
            {
                name: 'B.Tech. Food Technology',
                description: 'Engineering program focusing on food processing and technology.',
                duration: '4 Years',
                eligibility: '10+2 with PCM and minimum 50% marks',
                features: [
                    'Food Engineering',
                    'Process Automation',
                    'Food Preservation',
                    'Quality Control Systems',
                    'Industry Projects'
                ],
                careerOpportunities: [
                    'Food Process Engineer',
                    'Production Manager',
                    'Food Safety Engineer',
                    'Research Scientist',
                    'Quality Control Manager'
                ]
            }
        ]
    },
    {
        name: 'School of Health Sciences',
        icon: HealthIcon,
        courses: [
            {
                name: 'B.Sc. Medical Lab Technology',
                description: 'Program training students in diagnostic lab techniques and medical testing.',
                duration: '3 Years',
                eligibility: '10+2 with PCB and minimum 45% marks',
                features: [
                    'Clinical Biochemistry',
                    'Hematology',
                    'Microbiology Testing',
                    'Lab Management',
                    'Diagnostic Techniques'
                ],
                careerOpportunities: [
                    'Medical Lab Technician',
                    'Lab Supervisor',
                    'Diagnostic Specialist',
                    'Pathology Technician',
                    'Research Assistant'
                ]
            },
            {
                name: 'B.Sc. Radio Imaging Technology',
                description: 'Program focusing on medical imaging techniques like X-ray and MRI.',
                duration: '3 Years',
                eligibility: '10+2 with PCB and minimum 45% marks',
                features: [
                    'Radiographic Techniques',
                    'MRI and CT Scanning',
                    'Radiation Safety',
                    'Image Analysis',
                    'Clinical Training'
                ],
                careerOpportunities: [
                    'Radiologic Technologist',
                    'MRI Technician',
                    'CT Scan Specialist',
                    'Imaging Supervisor',
                    'Diagnostic Consultant'
                ]
            },
            {
                name: 'B.Sc. Operation Theatre Technology',
                description: 'Program training students to assist in surgical procedures and OT management.',
                duration: '3 Years',
                eligibility: '10+2 with PCB and minimum 45% marks',
                features: [
                    'Surgical Assistance',
                    'Sterilization Techniques',
                    'OT Equipment Handling',
                    'Anesthesia Support',
                    'Clinical Training'
                ],
                careerOpportunities: [
                    'OT Technician',
                    'Surgical Assistant',
                    'OT Supervisor',
                    'Anesthesia Technician',
                    'Healthcare Coordinator'
                ]
            },
            {
                name: 'B.Sc. Cardiac Care Technology',
                description: 'Program focusing on cardiac diagnostics and patient care.',
                duration: '3 Years',
                eligibility: '10+2 with PCB and minimum 45% marks',
                features: [
                    'ECG and Echo Techniques',
                    'Cardiac Catheterization',
                    'Heart Monitoring',
                    'Emergency Response',
                    'Clinical Training'
                ],
                careerOpportunities: [
                    'Cardiac Technician',
                    'Echo Technician',
                    'Cardiac Care Specialist',
                    'Cath Lab Technician',
                    'Heart Health Consultant'
                ]
            },
            {
                name: 'B.Sc. Dialysis Technology',
                description: 'Program training students in dialysis procedures and patient care.',
                duration: '3 Years',
                eligibility: '10+2 with PCB and minimum 45% marks',
                features: [
                    'Dialysis Machine Operation',
                    'Renal Care',
                    'Patient Monitoring',
                    'Infection Control',
                    'Clinical Training'
                ],
                careerOpportunities: [
                    'Dialysis Technician',
                    'Renal Care Specialist',
                    'Dialysis Unit Supervisor',
                    'Patient Care Coordinator',
                    'Healthcare Technician'
                ]
            },
            {
                name: 'B.Sc. Anaesthesia Technology',
                description: 'Program focusing on anesthesia administration and patient monitoring.',
                duration: '3 Years',
                eligibility: '10+2 with PCB and minimum 45% marks',
                features: [
                    'Anesthesia Techniques',
                    'Patient Monitoring',
                    'OT Support',
                    'Emergency Care',
                    'Clinical Training'
                ],
                careerOpportunities: [
                    'Anesthesia Technician',
                    'OT Assistant',
                    'Critical Care Technician',
                    'Anesthesia Supervisor',
                    'Healthcare Specialist'
                ]
            },
            {
                name: 'Bachelor in Hospital Administration (BHA)',
                description: 'Program focusing on healthcare management and hospital operations.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Hospital Management',
                    'Healthcare Policies',
                    'Financial Management',
                    'Patient Services',
                    'Quality Control'
                ],
                careerOpportunities: [
                    'Hospital Administrator',
                    'Healthcare Manager',
                    'Operations Manager',
                    'Patient Relations Manager',
                    'Health Policy Analyst'
                ]
            },
            {
                name: 'Bachelor in Public Health (BPH)',
                description: 'Program addressing public health issues, epidemiology, and health policies.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Epidemiology',
                    'Health Policy Analysis',
                    'Community Health',
                    'Biostatistics',
                    'Public Health Campaigns'
                ],
                careerOpportunities: [
                    'Public Health Officer',
                    'Epidemiologist',
                    'Health Program Manager',
                    'Community Health Educator',
                    'Policy Analyst'
                ]
            }
        ]
    },
    {
        name: 'School of Paramedical Sciences',
        icon: ParamedicalIcon,
        courses: [
            {
                name: 'BPT',
                description: 'Program in physiotherapy for rehabilitation and patient care.',
                duration: '4.5 Years',
                eligibility: '10+2 with PCB and minimum 50% marks',
                features: [
                    'Manual Therapy',
                    'Exercise Physiology',
                    'Rehabilitation Techniques',
                    'Clinical Training',
                    'Pain Management'
                ],
                careerOpportunities: [
                    'Physiotherapist',
                    'Rehabilitation Specialist',
                    'Sports Therapist',
                    'Clinical Physiotherapist',
                    'Wellness Consultant'
                ]
            },
            {
                name: 'BMLT',
                description: 'Program in medical lab technology for diagnostic testing.',
                duration: '3 Years',
                eligibility: '10+2 with PCB and minimum 45% marks',
                features: [
                    'Clinical Diagnostics',
                    'Pathology Testing',
                    'Lab Management',
                    'Biochemistry Analysis',
                    'Clinical Training'
                ],
                careerOpportunities: [
                    'Medical Lab Technician',
                    'Pathology Technician',
                    'Lab Supervisor',
                    'Diagnostic Specialist',
                    'Research Assistant'
                ]
            },
            {
                name: 'BMRIT',
                description: 'Program in medical radio imaging for diagnostic imaging techniques.',
                duration: '3 Years',
                eligibility: '10+2 with PCB and minimum 45% marks',
                features: [
                    'X-ray Imaging',
                    'MRI and CT Techniques',
                    'Radiation Safety',
                    'Image Processing',
                    'Clinical Training'
                ],
                careerOpportunities: [
                    'Radiologic Technologist',
                    'MRI Technician',
                    'CT Scan Specialist',
                    'Imaging Supervisor',
                    'Diagnostic Consultant'
                ]
            },
            {
                name: 'BOTT',
                description: 'Program in operation theatre technology for surgical assistance.',
                duration: '3 Years',
                eligibility: '10+2 with PCB and minimum 45% marks',
                features: [
                    'Surgical Procedures',
                    'OT Management',
                    'Sterilization Techniques',
                    'Anesthesia Support',
                    'Clinical Training'
                ],
                careerOpportunities: [
                    'OT Technician',
                    'Surgical Assistant',
                    'OT Supervisor',
                    'Anesthesia Technician',
                    'Healthcare Coordinator'
                ]
            }
        ]
    },
    {
        name: 'School of Arts and Humanities',
        icon: ArtsIcon,
        courses: [
            {
                name: 'BA Yoga',
                description: 'Program focusing on yoga practices, philosophy, and wellness.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Yoga Asanas',
                    'Meditation Techniques',
                    'Yoga Philosophy',
                    'Wellness Coaching',
                    'Practical Training'
                ],
                careerOpportunities: [
                    'Yoga Instructor',
                    'Wellness Coach',
                    'Meditation Trainer',
                    'Yoga Therapist',
                    'Health Consultant'
                ]
            },
            {
                name: 'BA Maths',
                description: 'Program focusing on mathematical theories and applications.',
                duration: '3 Years',
                eligibility: '10+2 with PCM and minimum 45% marks',
                features: [
                    'Calculus',
                    'Algebra',
                    'Statistics',
                    'Mathematical Modeling',
                    'Problem Solving'
                ],
                careerOpportunities: [
                    'Mathematician',
                    'Data Analyst',
                    'Statistician',
                    'Teacher',
                    'Research Assistant'
                ]
            },
            {
                name: 'BA Clinical Psychology',
                description: 'Program focusing on psychological assessment and therapeutic techniques.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Psychological Assessment',
                    'Counseling Techniques',
                    'Behavioral Therapy',
                    'Mental Health Awareness',
                    'Internships'
                ],
                careerOpportunities: [
                    'Clinical Psychologist',
                    'Counselor',
                    'Therapist',
                    'Mental Health Coordinator',
                    'Research Assistant'
                ]
            },
            {
                name: 'BA Psychology',
                description: 'Program studying human behavior, cognition, and emotions.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Cognitive Psychology',
                    'Social Psychology',
                    'Developmental Psychology',
                    'Research Methods',
                    'Counseling Skills'
                ],
                careerOpportunities: [
                    'Psychologist',
                    'Counselor',
                    'HR Specialist',
                    'Social Worker',
                    'Research Analyst'
                ]
            },
            {
                name: 'BA English',
                description: 'Program focusing on English literature, language, and communication.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'English Literature',
                    'Creative Writing',
                    'Linguistics',
                    'Communication Skills',
                    'Literary Analysis'
                ],
                careerOpportunities: [
                    'Content Writer',
                    'Editor',
                    'Teacher',
                    'Journalist',
                    'Public Relations Specialist'
                ]
            },
            {
                name: 'BA Sociology',
                description: 'Program studying social structures, institutions, and human interactions.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Social Theories',
                    'Cultural Studies',
                    'Social Research',
                    'Community Development',
                    'Sociological Analysis'
                ],
                careerOpportunities: [
                    'Sociologist',
                    'Social Worker',
                    'Community Organizer',
                    'Policy Analyst',
                    'Researcher'
                ]
            },
            {
                name: 'BA Political Science',
                description: 'Program focusing on political systems, governance, and international relations.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Political Theories',
                    'International Relations',
                    'Public Policy',
                    'Governance Systems',
                    'Research Projects'
                ],
                careerOpportunities: [
                    'Political Analyst',
                    'Policy Advisor',
                    'Diplomat',
                    'Public Administrator',
                    'Researcher'
                ]
            },
            {
                name: 'BA Economics',
                description: 'Program studying economic theories, policies, and data analysis.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Microeconomics',
                    'Macroeconomics',
                    'Econometrics',
                    'Economic Policy',
                    'Data Analysis'
                ],
                careerOpportunities: [
                    'Economist',
                    'Financial Analyst',
                    'Policy Analyst',
                    'Data Analyst',
                    'Economic Consultant'
                ]
            },
            {
                name: 'BA Hindi',
                description: 'Program focusing on Hindi literature, language, and culture.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Hindi Literature',
                    'Creative Writing',
                    'Linguistics',
                    'Cultural Studies',
                    'Translation Skills'
                ],
                careerOpportunities: [
                    'Content Writer',
                    'Translator',
                    'Teacher',
                    'Journalist',
                    'Editor'
                ]
            },
            {
                name: 'BA Geography',
                description: 'Program studying physical and human geography, GIS, and environmental issues.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Physical Geography',
                    'Human Geography',
                    'GIS Mapping',
                    'Environmental Studies',
                    'Field Work'
                ],
                careerOpportunities: [
                    'Geographer',
                    'GIS Analyst',
                    'Environmental Consultant',
                    'Urban Planner',
                    'Researcher'
                ]
            },
            {
                name: 'BA Fine Arts',
                description: 'Program focusing on visual arts, painting, and creative expression.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Painting Techniques',
                    'Sculpture',
                    'Art History',
                    'Digital Art',
                    'Exhibition Projects'
                ],
                careerOpportunities: [
                    'Artist',
                    'Art Curator',
                    'Graphic Designer',
                    'Art Teacher',
                    'Illustrator'
                ]
            },
            {
                name: 'BA Journalism & Mass Communication',
                description: 'Program covering media, journalism, and communication strategies.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'News Reporting',
                    'Media Production',
                    'Digital Journalism',
                    'Public Relations',
                    'Media Projects'
                ],
                careerOpportunities: [
                    'Journalist',
                    'Media Producer',
                    'Public Relations Officer',
                    'Content Creator',
                    'News Anchor'
                ]
            }
        ]
    },
    {
        name: 'School of Skill Development and Vocational Studies',
        icon: VocationalIcon,
        courses: [
            {
                name: 'Bachelor in E-commerce & Digital Marketing',
                description: 'Program focusing on online business and digital marketing strategies.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'E-commerce Platforms',
                    'SEO and SEM',
                    'Social Media Marketing',
                    'Analytics Tools',
                    'Digital Campaigns'
                ],
                careerOpportunities: [
                    'E-commerce Manager',
                    'Digital Marketing Specialist',
                    'SEO Analyst',
                    'Social Media Manager',
                    'Online Business Consultant'
                ]
            },
            {
                name: 'Bachelor in Bakery & Pastry Arts',
                description: 'Program focusing on advanced baking techniques and pastry arts for culinary careers.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Advanced Baking Techniques',
                    'Pastry Design',
                    'Chocolate Artistry',
                    'Bakery Management',
                    'Culinary Innovation'
                ],
                careerOpportunities: [
                    'Pastry Chef',
                    'Bakery Owner',
                    'Culinary Instructor',
                    'Dessert Consultant',
                    'Bakery Manager'
                ]
            },
            {
                name: 'Bachelor in Sales & Marketing',
                description: 'Program covering sales techniques, marketing strategies, and consumer behavior.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Sales Strategies',
                    'Market Research',
                    'Brand Management',
                    'Digital Marketing',
                    'Customer Relationship Management'
                ],
                careerOpportunities: [
                    'Sales Manager',
                    'Marketing Executive',
                    'Brand Manager',
                    'Market Research Analyst',
                    'Advertising Specialist'
                ]
            },
            {
                name: 'Bachelor in Food Production',
                description: 'Program focusing on culinary arts, food production, and kitchen management.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Culinary Techniques',
                    'International Cuisine',
                    'Kitchen Operations',
                    'Food Safety',
                    'Menu Planning'
                ],
                careerOpportunities: [
                    'Executive Chef',
                    'Food Production Manager',
                    'Culinary Instructor',
                    'Catering Manager',
                    'Kitchen Supervisor'
                ]
            },
            {
                name: 'Bachelor in Pharma Assistance',
                description: 'Program training students to assist pharmacists in healthcare settings.',
                duration: '3 Years',
                eligibility: '10+2 with PCB/PCM and minimum 45% marks',
                features: [
                    'Pharmaceutical Basics',
                    'Drug Dispensing',
                    'Patient Counseling',
                    'Pharmacy Operations',
                    'Clinical Support'
                ],
                careerOpportunities: [
                    'Pharmacy Assistant',
                    'Medical Representative',
                    'Pharmacy Technician',
                    'Healthcare Coordinator',
                    'Drug Store Manager'
                ]
            },
            {
                name: 'Bachelor in Computer Technology',
                description: 'Program covering IT skills, software development, and computer systems.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Programming Languages',
                    'Web Development',
                    'Network Administration',
                    'Database Management',
                    'IT Project Work'
                ],
                careerOpportunities: [
                    'Software Developer',
                    'IT Support Specialist',
                    'Network Administrator',
                    'Web Developer',
                    'System Analyst'
                ]
            },
            {
                name: 'Bachelor in Aviation',
                description: 'Program focusing on aviation operations, safety, and management.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Aviation Safety',
                    'Airport Operations',
                    'Flight Operations',
                    'Customer Service',
                    'Aviation Regulations'
                ],
                careerOpportunities: [
                    'Airport Manager',
                    'Aviation Safety Officer',
                    'Flight Operations Coordinator',
                    'Ground Staff Supervisor',
                    'Aviation Consultant'
                ]
            },
            {
                name: 'Bachelor in Welding',
                description: 'Program training students in welding techniques and fabrication.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Welding Techniques',
                    'Metal Fabrication',
                    'Safety Standards',
                    'Blueprint Reading',
                    'Practical Training'
                ],
                careerOpportunities: [
                    'Welder',
                    'Fabrication Supervisor',
                    'Welding Inspector',
                    'Maintenance Technician',
                    'Welding Instructor'
                ]
            },
            {
                name: 'Bachelor in AIML & Data Analysis',
                description: 'Program focusing on AI, machine learning, and data analytics.',
                duration: '3 Years',
                eligibility: '10+2 with PCM and minimum 45% marks',
                features: [
                    'Machine Learning Algorithms',
                    'Data Visualization',
                    'AI Programming',
                    'Big Data Analytics',
                    'Project Development'
                ],
                careerOpportunities: [
                    'AI Developer',
                    'Data Analyst',
                    'Machine Learning Engineer',
                    'Data Scientist',
                    'AI Consultant'
                ]
            },
            {
                name: 'Bachelor in Hotel & Hospitality Management',
                description: 'Program covering hotel operations, hospitality, and customer service.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Hospitality Management',
                    'Front Office Operations',
                    'Food and Beverage Service',
                    'Event Management',
                    'Industry Internships'
                ],
                careerOpportunities: [
                    'Hotel Manager',
                    'Guest Relations Manager',
                    'Event Coordinator',
                    'Hospitality Consultant',
                    'Resort Manager'
                ]
            },
            {
                name: 'Bachelor in Finance, Taxation & Accounting',
                description: 'Program focusing on financial management, taxation, and accounting principles.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Financial Accounting',
                    'Taxation Laws',
                    'Auditing',
                    'Corporate Finance',
                    'GST Compliance'
                ],
                careerOpportunities: [
                    'Accountant',
                    'Tax Consultant',
                    'Financial Analyst',
                    'Auditor',
                    'Finance Manager'
                ]
            },
            {
                name: 'Bachelor in Mass Media & Production',
                description: 'Program covering media production, journalism, and content creation.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Media Production',
                    'Journalism Techniques',
                    'Video Editing',
                    'Content Creation',
                    'Media Projects'
                ],
                careerOpportunities: [
                    'Media Producer',
                    'Journalist',
                    'Video Editor',
                    'Content Creator',
                    'Media Manager'
                ]
            },
            {
                name: 'Bachelor in Food Processing & Nutrition Management',
                description: 'Program focusing on food processing, nutrition, and quality control.',
                duration: '3 Years',
                eligibility: '10+2 with PCB/PCM and minimum 45% marks',
                features: [
                    'Food Processing Techniques',
                    'Nutrition Science',
                    'Quality Control',
                    'Food Safety Standards',
                    'Lab Work'
                ],
                careerOpportunities: [
                    'Food Technologist',
                    'Nutritionist',
                    'Quality Control Manager',
                    'Food Safety Officer',
                    'Product Developer'
                ]
            },
            {
                name: 'Bachelor in Patient & Health Care Management',
                description: 'Program focusing on healthcare management and patient care services.',
                duration: '3 Years',
                eligibility: '10+2 from any stream with minimum 45% marks',
                features: [
                    'Healthcare Operations',
                    'Patient Care Services',
                    'Health Policy',
                    'Hospital Management',
                    'Quality Assurance'
                ],
                careerOpportunities: [
                    'Healthcare Administrator',
                    'Patient Care Coordinator',
                    'Hospital Manager',
                    'Health Services Manager',
                    'Policy Analyst'
                ]
            },
            {
                name: 'Bachelor in Agriculture',
                description: 'Program covering modern agricultural practices and agribusiness.',
                duration: '3 Years',
                eligibility: '10+2 with PCB/PCM and minimum 45% marks',
                features: [
                    'Crop Management',
                    'Soil Science',
                    'Agribusiness',
                    'Sustainable Farming',
                    'Field Work'
                ],
                careerOpportunities: [
                    'Agricultural Officer',
                    'Farm Manager',
                    'Agribusiness Consultant',
                    'Crop Consultant',
                    'Research Assistant'
                ]
            }
        ]
    },
    {
        name: 'School of Nursing',
        icon: NursingIcon,
        courses: [
            {
                name: 'B.Sc. Nursing',
                description: 'Comprehensive program in nursing care, patient management, and healthcare.',
                duration: '4 Years',
                eligibility: '10+2 with PCB and minimum 50% marks',
                features: [
                    'Clinical Nursing',
                    'Patient Care',
                    'Medical-Surgical Nursing',
                    'Community Health',
                    'Clinical Training'
                ],
                careerOpportunities: [
                    'Registered Nurse',
                    'Clinical Nurse Specialist',
                    'Nurse Educator',
                    'Healthcare Administrator',
                    'Public Health Nurse'
                ]
            }
        ]
    },
    {
        name: 'School of Law and Legal Studies',
        icon: LawIcon,
        courses: [
            {
                name: 'BA LLB',
                description: 'Integrated program combining arts and law for legal education.',
                duration: '5 Years',
                eligibility: '10+2 from any stream with minimum 50% marks',
                features: [
                    'Constitutional Law',
                    'Criminal Law',
                    'Civil Law',
                    'Legal Research',
                    'Moot Court Practice'
                ],
                careerOpportunities: [
                    'Lawyer',
                    'Legal Advisor',
                    'Corporate Counsel',
                    'Public Prosecutor',
                    'Judge'
                ]
            },
            {
                name: 'BBA LLB',
                description: 'Integrated program combining business administration and law.',
                duration: '5 Years',
                eligibility: '10+2 from any stream with minimum 50% marks',
                features: [
                    'Corporate Law',
                    'Business Law',
                    'Contract Law',
                    'Legal Drafting',
                    'Moot Court Practice'
                ],
                careerOpportunities: [
                    'Corporate Lawyer',
                    'Legal Consultant',
                    'Compliance Officer',
                    'Business Law Advisor',
                    'Judge'
                ]
            },
            {
                name: 'LLB',
                description: 'Program focusing on legal education and practice.',
                duration: '3 Years',
                eligibility: 'Bachelor’s degree in any discipline with minimum 50% marks',
                features: [
                    'Criminal Law',
                    'Civil Law',
                    'Legal Procedures',
                    'Advocacy Skills',
                    'Legal Research'
                ],
                careerOpportunities: [
                    'Lawyer',
                    'Legal Advisor',
                    'Public Prosecutor',
                    'Legal Researcher',
                    'Judge'
                ]
            }
        ]
    },
    {
        name: 'School of Education',
        icon: EducationIcon,
        courses: [
            {
                name: 'Bachelor of Education (B.Ed)',
                description: 'Program preparing students for teaching and educational administration.',
                duration: '2 Years',
                eligibility: 'Bachelor’s degree in any discipline with minimum 50% marks',
                features: [
                    'Pedagogy Techniques',
                    'Curriculum Development',
                    'Educational Psychology',
                    'Classroom Management',
                    'Teaching Practice'
                ],
                careerOpportunities: [
                    'Teacher',
                    'Educational Administrator',
                    'Curriculum Developer',
                    'Education Consultant',
                    'School Counselor'
                ]
            }
        ]
    }
];


const UGCourses = () => {
    return (
        <div className='w-full relative font-poppins bg-gradient-to-br from-green-50 to-white min-h-screen'>
            {/* Hero Section */}
            <motion.div
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="relative pt-[100px] md:pt-[150px] text-center"
            >
                <h2 className="mb-4 text-4xl md:text-6xl tracking-tight font-bold text-[#0e4d38]">
                    Undergraduate Courses
                </h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto px-4">
                    Comprehensive Bachelor's Programs for Future Professionals
                </p>
            </motion.div>

            {/* Main Content */}
            <div className='w-11/12 mx-auto mb-[50px] relative z-10'>
                {/* Course Overview Section */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 0.2 }}
                    className="flex flex-col gap-5 md:gap-[100px] md:flex-row justify-between items-center my-16"
                >
                    {/* UG Image */}
                    <motion.div
                        whileHover={{
                            scale: 1.05,
                            rotate: 2,
                            transition: { duration: 0.3 }
                        }}
                        className="relative rounded-2xl overflow-hidden shadow-2xl"
                    >
                        <img
                            src={UG}
                            className="w-[400px] h-[400px] max-h-[450px] object-contain md:object-cover"
                            alt="Undergraduate Courses"
                        />
                    </motion.div>

                    {/* Description Section */}
                    <div className="w-full md:w-1/2 space-y-6">
                        <h3 className="text-3xl font-bold text-[#0e4d38] mb-4">
                            Why Choose Our UG Programs?
                        </h3>
                        <div className="space-y-4 bg-white p-6 rounded-lg shadow-md">
                            {[
                                {
                                    icon: <CheckCircle className="text-green-500 mr-3" />,
                                    text: "Industry-Relevant Curriculum"
                                },
                                {
                                    icon: <CheckCircle className="text-green-600 mr-3" />,
                                    text: "Experienced Faculty"
                                },
                                {
                                    icon: <CheckCircle className="text-green-700 mr-3" />,
                                    text: "Practical Learning Approach"
                                },
                                {
                                    icon: <CheckCircle className="text-green-800 mr-3" />,
                                    text: "Excellent Placement Record"
                                }
                            ].map((item, index) => (
                                <div key={index} className="flex items-center">
                                    {item.icon}
                                    <span className="text-gray-700">{item.text}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </motion.div>

                {/* Schools Section */}
                <div className="space-y-16">
                    {ugSchools.map((school, schoolIndex) => (
                        <motion.div
                            key={schoolIndex}
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.1 * schoolIndex }}
                            className="bg-white rounded-xl shadow-lg overflow-hidden"
                        >
                            {/* School Header */}
                            <div className="bg-gradient-to-r from-green-600 to-green-800 p-6">
                                <div className="flex items-center space-x-4">
                                    <school.icon sx={{ color: 'white', fontSize: 32 }} />
                                    <h3 className="text-white text-2xl font-bold">{school.name}</h3>
                                </div>
                            </div>

                            {/* Courses List */}
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
                                {school.courses.map((course, index) => (
                                    <motion.div
                                        key={index}
                                        whileHover={{ y: -5 }}
                                        className="border border-green-100 rounded-lg overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow"
                                    >
                                        <div className="p-6">
                                            <div className="flex items-center mb-4">
                                                <school.icon sx={{ color: '#0e4d38', fontSize: 28, mr: 2 }} />
                                                <h4 className="text-lg font-semibold text-green-800">{course.name}</h4>
                                            </div>
                                            <p className="text-gray-600 text-sm mb-4">{course.description}</p>
                                            
                                            <div className="mb-4">
                                                <div className="text-sm text-green-700 font-medium mb-1">
                                                    Duration: {course.duration}
                                                </div>
                                                <div className="text-sm text-green-700 font-medium">
                                                    Eligibility: {course.eligibility}
                                                </div>
                                            </div>
                                            
                                            <div className="mb-4">
                                                <h5 className="text-sm font-semibold text-green-800 mb-2">
                                                    Key Features:
                                                </h5>
                                                <ul className="text-sm text-gray-600 space-y-1">
                                                    {course.features.slice(0, 3).map((feature, idx) => (
                                                        <li key={idx} className="flex items-start">
                                                            <CheckCircle className="text-green-500 mt-0.5 mr-2 flex-shrink-0" size={16} />
                                                            <span>{feature}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>

                                            <div className="mt-4">
                                                <h5 className="text-sm font-semibold text-green-800 mb-2">
                                                    Career Opportunities:
                                                </h5>
                                                <ul className="text-sm text-gray-600 space-y-1">
                                                    {course.careerOpportunities.slice(0, 2).map((career, idx) => (
                                                        <li key={idx} className="flex items-start">
                                                            <CheckCircle className="text-green-500 mt-0.5 mr-2 flex-shrink-0" size={16} />
                                                            <span>{career}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="px-6 pb-4">
                                            <Link to="/programmes">
                                                <button className="w-full bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded transition-colors">
                                                    View Details
                                                </button>
                                            </Link>
                                        </div>
                                    </motion.div>
                                ))}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default UGCourses;